import './style.scss';
import ControlMessage from './controlmessage.js';

export default ControlMessage;